import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../../lib/api.js";

export interface DashboardSummary {
  range: { from: string; to: string };
  kpis: {
    sentToday: number;
    sentYesterday: number;
    /** Business-initiated conversations in the rolling 24h — the tier meter's unit. */
    tierUsedToday: number;
    tierLimit: number | null;
    /** Whether the brand's number is live on the Cloud API. */
    connected: boolean;
    deliveredPct: number | null;
    quality: string;
    metaVerified: boolean;
    optinTotal: number;
    optinNew7d: number;
  };
  customerMix: { new: number; repeat: number; vip: number };
  sla: {
    medianMins: number | null;
    prevMins: number | null;
    within15: number | null;
    totalReplies: number;
  };
  volume: Array<{ date: string; inbound: number; outbound: number }>;
  inboxPreview: Array<{ id: string; name: string; snippet: string; unread: number }>;
  orderLog: Array<{ id: string; at: string; customer: string; event: string; status: string }>;
  nextTier: { limit: number; unlock: string } | null;
}

export function useDashboard(businessId: string) {
  return useQuery<DashboardSummary>({
    queryKey: [businessId, "dashboard"],
    queryFn: () => apiFetch(`/api/v1/dashboard?business=${businessId}`),
  });
}
